import type { TRouteMatcher } from './models';

/** Метод который используется по умолчанию
 * для сопоставления текущего route
 * с наименованием (name) в конткретных Routes.
 */
export const defaultMatcher: TRouteMatcher = ({ invert, name, route }) => {
    const isMatched = Array.isArray(name) ? name.includes(route) : route === name;

    return invert ? !isMatched : isMatched;
};
